import React from 'react';
import { Result, Button } from 'antd';
import PageWrapper from '../components/layout/PageWrapper';
import { CONTACT_PHONE } from '../constants';


const NotFoundPage = () => {
    return (
        <PageWrapper>
            <Result
                status="404"
                title="404"
                subTitle={
                    <span>
                        Oh no! You're not supposed to be here.
                        <br />
                        Something's gone wrong. If you need help, please contact us directly on { CONTACT_PHONE }.
                        <br />
                        <br />
                        <Button type="primary" href="/">
                            Back to home
                        </Button>
                    </span>
                }
            />
        </PageWrapper>
    );
};

export default NotFoundPage;
